<div class="flex column-direction between-spacer contenedor-opciones">
  <div style="max-height: 100%">
    <router-outlet></router-outlet>
  </div>
  <div class="total">
    <button class="btn-limpiar" (click)="salirVenta()">LIMPIAR</button>
    <button class="btn-pagar" (click)="pagar()">PAGAR</button>
  </div>
</div>
